import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useEventListener } from '@beef/react';
import { AnalyticsPusherLinks } from "../utils/analytics";

/**
 * Обработка кликов по ссылкам, которые не являются компонентом Link, с отправкой аналитики
 */
export var useAnalyticsLinks = function useAnalyticsLinks(ref, blockIndex) {
  var handleLinkClick = function handleLinkClick(event) {
    var target = event.target;
    if (target.tagName !== 'A' || target.getAttribute('data-component') === 'Link') return;
    var index = _toConsumableArray(ref.current.getElementsByTagName('a')).indexOf(target);
    var href = target.getAttribute('href');
    if (href) {
      AnalyticsPusherLinks.pushClickEvent(href);
      AnalyticsPusherLinks.pushReachGoal(href, blockIndex, index);
    }
  };
  useEventListener('click', handleLinkClick, ref);
};